import React from 'react';

import { IconArrowDown, IconArrowRight } from '@xingternal/icons';

import { useBreakpoints } from '@/hooks';
import { ExtendedContact } from '@/types';

import Contact from '../contact';
import FirstDegreeContact from '../first-degree-contact';

import * as S from './second-degree-contact-component.styles';
import styles from './second-degree-contact.css';

type Props = {
  contact?: ExtendedContact;
  hint?: string | null;
};

const SecondDegreeContact: React.FC<Props> = ({ contact, hint }) => {
  const secondDegreeContact = contact?.user;
  const firstDegreeContact = contact?.connectedBy?.[0]?.user;

  const { isMobile } = useBreakpoints();

  return (
    <S.ContactWrapper>
      <Contact user={secondDegreeContact} hint={hint} connectionDegree={2} />
      {isMobile ? (
        <div className={styles.mobileSeparator}>
          <IconArrowDown width={16} height={16} />
        </div>
      ) : (
        <IconArrowRight width={16} height={16} className={styles.separator} />
      )}
      <FirstDegreeContact
        user={firstDegreeContact}
        messengerContextId="jobs_contact_network"
        entryPoint="jobs_job_detail_network"
        hint={hint}
        isCommonContact
      />
    </S.ContactWrapper>
  );
};

export default SecondDegreeContact;
